import AlertCustom from './AlertCustom';

export default AlertCustom;
